// extracted by mini-css-extract-plugin
module.exports = {"token_select":"style_token_select__OUpP_","token_select_option":"style_token_select_option__2OfnB"};